import { useCallback, useState } from "react";
import { Dialog, DialogContent, DialogActions, Checkbox, FormControlLabel, Skeleton, Autocomplete, TextField, DialogTitle, DialogContentText, Alert } from "@mui/material";
import { Localized } from "@fluent/react";
import { useAppSelector } from "../../../app/hooks";
import { selectAllUsers, User } from "../../users/usersSlice";
import { LoadUsers } from "../../../app/AppDataLoader";
import { selectLoggedUser } from "../../user/userSlice";
import { CancelButton } from "../../../app/components/CancelButton";
import { YesButton } from "../../../app/components/YesButton";

const InternalPublishDialog = ({ saving, handleConfirmPublishClick, handleCancelPublishClick }) => {
    const [addMeToTeam, setAddMeToTeam] = useState(true);
    const allUsers = useAppSelector(selectAllUsers)
    const currentUser = useAppSelector(selectLoggedUser)
    const [selectedUser, setSelectedUser] = useState<User | null>(null)
    const isCurrentUserSelected = selectedUser?.userName === currentUser;
    const [showError, setShowError] = useState(false);


    const handleUserChange = useCallback((_, newUser) => {
        setSelectedUser(newUser)
    }, [currentUser])

    const handleConfirm = () => {
        if (!selectedUser) {
            setShowError(true);
            return;
        }
        const editors: string[] = [];
        if (addMeToTeam && currentUser && currentUser !== selectedUser.userName) {
            editors.push(currentUser);
        }
        handleConfirmPublishClick(selectedUser.userName, editors);
    };

    return (
        <Dialog key="sendforcommenting" open={true}>
            <DialogContent>
                <DialogTitle>
                    <Localized id=''>Do you want to send URS for commenting?</Localized>
                </DialogTitle>

                <LoadUsers component={<Skeleton />}>
                    <Autocomplete
                        sx={{
                            marginTop: 1,
                        }}
                        options={allUsers}
                        value={selectedUser}
                        onChange={handleUserChange}
                        getOptionLabel={({ firstname, surname, email }) => `${surname} ${firstname} (${email})`}
                        renderInput={params =>
                            <TextField {...params}
                                error={showError && !selectedUser}
                                helperText={showError && !selectedUser ? "Wybierz właściciela procesu" : ""}
                                label={
                                    <Localized id="team-role-process-owner">
                                        <span>_Process owner</span>
                                    </Localized>
                                }
                            />
                        }
                    />
                </LoadUsers>
                <FormControlLabel
                    control={
                        <Checkbox
                            checked={addMeToTeam}
                            onChange={(e) => setAddMeToTeam(e.target.checked)}
                            disabled={isCurrentUserSelected}
                        />
                    }
                    label="Keep me as a team member"
                />
            </DialogContent>
            <DialogActions>
                <YesButton loading={saving} onClick={handleConfirm} />
                <CancelButton loading={saving} onClick={handleCancelPublishClick} />
            </DialogActions>
        </Dialog>
    );
};

export default InternalPublishDialog;
